import React from "react";
import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { LinkingPopupService } from "@/Common/Components/Modals/LinkingPopup/LinkingPopupService";
import { CommonTableHeaderComponent } from "@/Common/Components/Tables/CommonTableHeaderComponent";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { MyleTableColumnOrderControlv2 } from "@/Common/Components/Tables/MyleTableColumnOrderControlv2";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { PendingApprovalStatus, PortfolioNotesSortOrderType, RedirectTo } from "@/Common/Models/UI/Enums";
import { ColumnConfigurationModel } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { ApssClient } from "@/Patient/Api/Apss/ApssClient";
import { PendingApprovalSettingsContainer } from "@/Portfolio/Components/PendingApprovalSettingsContainer";
import { ResidentApprovalPortfolioPopup } from "@/Portfolio/Components/ResidentApprovalPortfolioPopup";
import { Annexes, PendingApprovalsItem } from "@/Portfolio/Models/MyNotesInboxItem";
import { PendingApprovalsTableItem } from "@/Portfolio/Models/MyNotesInboxTableItem";
import { IPendingApprovalInboxModel } from "@/Portfolio/Models/UI/IPendingApprovalInboxModel";
import { PortfolioSaveOptionKey } from "./PortfolioSaveOptionKey";

interface IPendingApprovalInbox {
    Model: IPendingApprovalInboxModel;
}

class PendingApprovalInbox extends React.Component<IPendingApprovalInbox, never> {
    private helper: MyleHelper = new MyleHelper();

    public componentDidMount(): void {
        $(window).trigger("resize");
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_Reload);
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        const saveOptionKey = PortfolioSaveOptionKey.PendingApproval;
        const columnsOptions = this.helper.loadTableColumnOptionsFromSettings(saveOptionKey, this.getMyleTableColumnsDefaultOptions());
        const tableColumns = this.getTableColumns(columnsOptions);
        const tableRenderOptions = this.loadTableRenderOptions(columnsOptions);
        const cfgm: ColumnConfigurationModel[] = this.helper.castColumnConfigurationToMyleTableColumnOptions(columnsOptions.toArray());
        const leftSideWidth = (this.props.Model.get("HasNotePDF") === true && this.props.Model.get("PdfNoteOpen")) ? "35%" : "100%";
        const rightSideWidth = (this.props.Model.get("HasNotePDF") === true && this.props.Model.get("PdfNoteOpen")) ? "65%" : "100%";

        let selectedEncounter = this.getSelectedEncounter();

        if (selectedEncounter == null) {
            // select the next one according to saved
            const selectedIndex = this.props.Model.get("SelectedNoteIndex");
            if (selectedIndex != null && selectedIndex > -1) {
                if (selectedIndex >= this.props.Model.get("TableData").count()) {
                    selectedEncounter = this.props.Model.get("TableData").toArray()[this.props.Model.get("TableData").count() - 1];
                }
                else
                    selectedEncounter = this.props.Model.get("TableData").toArray()[selectedIndex];

                // simulate a row click to get pdf preview of note
                window.setTimeout(() => {
                    const operation = new LocalEvent(LocalOperations.Portfolio.PendingApproval_OnEncounterClick);
                    operation.AddItem("target", MyleTableTarget.Myle_PortfolioPendingApproval_RowClick);
                    operation.AddItem("event", null);
                    operation.AddItem("rowData", (selectedEncounter && selectedEncounter.Model) ? selectedEncounter.Model : null);
                    LocalEventDispatcher.dispatch(operation);
                });
            }
        }
        const isSelectedStillInList = selectedEncounter != null;

        const previewUrl = apiSettings.buildAppUrl(
            `api/pdf/fetch/${this.props.Model.get("NoteFileName")}`,
            {
                auth: true,
                hash: "toolbar=0&zoom=80"
            }
        );

        return (
            <div className="workspace">
                {this.props.Model.get("PendingNotesPopup") === true && (
                    <ResidentApprovalPortfolioPopup onCloseCallback={this.onCloseNotesPopup.bind(this)} Model={this.props.Model} />
                )}
                <CommonTableHeaderComponent
                    title={this.getHeaderTitle()}
                    searchText={this.props.Model.get("SearchText")}
                    searchPlaceholder={cacheStore.GetString("SearchLabel")}
                    onSearch={text => sessionStore.dispatch(LocalOperations.Portfolio.PendingApproval_SearchTextChanged, { value: text })}
                    onRefreshClick={() => sessionStore.dispatch(LocalOperations.Portfolio.PendingApproval_Reload)}
                    onSettingsClick={() => sessionStore.dispatch(LocalOperations.Portfolio.PendingApproval_SearchSettings_ShowOptionsButtonClick)}
                />

                <div id="posref" className="tb ws-scrollable">
                    {this.props.Model.get("ShowPendingApprovalDisplaySettings")
                        && <PendingApprovalSettingsContainer className="filter-component filter-component-responsive" Model={this.props.Model} />
                    }

                    <div className="flex-container">
                        <div style={{ "width": leftSideWidth }}>

                            <MyleTable
                                TableRenderOptions={tableRenderOptions}
                                TableId="PendingApprovalInbox_main_tb"
                                Columns={tableColumns}
                                DataSource={this.props.Model.get("TableData")}
                                ColumnsPreferencesChangedOperation={ServerOperations.Server.Myle_UpdateUserSettings}
                                RowClickOperation={LocalOperations.Portfolio.PendingApproval_OnEncounterClick}
                                RowClickTarget={MyleTableTarget.Myle_PortfolioPendingApproval_RowClick}
                                SaveOptionskeyTarget={saveOptionKey}
                                ColumnSortTarget={MyleTableTarget.Myle_PortfolioMyNotes_Resident_Search_ColumnSortClick}
                                DefaultSelectedItem={selectedEncounter}
                                IsRowLocked={(item: any) => item.Model.IsAccessProhibited}
                                TableDataCy="portfolio-table"
                            />

                        </div>
                        <div className="aside-handle" style={{ "paddingTop": "370px" }} onClick={() => this.toggleShowPdfNote()}>
                            <div>
                                <div className="slide-menu-icon blue "><span /><span /><span /></div>
                            </div>
                        </div>

                        {this.props.Model.get("PdfNoteOpen") && this.props.Model.get("HasNotePDF") === true && isSelectedStillInList && (
                            <div className="flex-container" style={{ "width": rightSideWidth, "flexDirection": "column" }} data-cy="pendingApproval-pdfNote">

                                <iframe src={previewUrl} height="100%" width="100%" />
                                {this.props.Model.get("SelectedPendingApprovalStatus") != PendingApprovalStatus.Approved && (
                                    <div className="flex-container" style={{ backgroundColor: "#F4F6F9", height: "67px" }}>
                                        {sessionStore.getCurrentEmployee().ContactId === this.props.Model.get("SelectedPendingApprovalSupervisorContactId") && (
                                            <div className="flex-container" style={{ paddingLeft: "5px", flexGrow: 1 }}>
                                                <textarea className="form-control" style={{ overflowX: "hidden", flexGrow: 1, marginTop: "10px", marginRight: "5px", resize: "none" }} onChange={this.onReturnPendingApprovalMessageChange.bind(this)} value={this.props.Model.get("ReturnPendingApprovalMessage")} rows={4} />
                                            </div>
                                        )}
                                        {EmployeeTitleHelper.isStudent(sessionStore.myleEmployeeTitle) && (
                                            <div className="text-right" style={{ paddingTop: "5px", marginLeft: "20px" }}>
                                                <button
                                                    className="btn btn-primary push-right-5"
                                                    onClick={this.onModifyEncounterClick.bind(this)}
                                                >
                                                    {cacheStore.GetString("ModifyLabel")}
                                                </button>
                                            </div>
                                        )}
                                        {sessionStore.getCurrentEmployee().ContactId === this.props.Model.get("SelectedPendingApprovalSupervisorContactId") && (
                                            <div style={{ justifyContent: "flex-end", paddingRight: "10px", paddingTop: "20px", display: "flex" }}>
                                                <button className="btn btn-primary push-right-5" onClick={this.onModifyEncounterClick.bind(this)}>{cacheStore.GetString("ModifyLabel")}</button>
                                                <button className="btn btn-primary push-right-5" onClick={this.onReturnClick.bind(this)}>{cacheStore.GetString("ReturnLabel")}</button>
                                                <button className="btn btn-primary" onClick={this.onApprovePendingApprovalClick.bind(this)}>{cacheStore.GetString("ApproveLabel")}</button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {!this.props.Model.get("PdfNoteOpen") &&
                            <div />
                        }
                    </div>
                </div>

                {this.props.Model.get("ColumnOrderingPopupOpen") && (
                    <MyleTableColumnOrderControlv2
                        TableColumns={cfgm}
                        SaveOptionskeyTarget={saveOptionKey}
                        ContainerId="columnSettingsPopup"
                        CloseColumOrder={LocalOperations.Portfolio.PendingApproval_SearchSettings_ColumnOrderingPopup_Close}
                    />
                )}
            </div>
        );
    }

    private getMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        const cols: MyleTableColumnOptions[] = [];

        const c_opt1 = new MyleTableColumnOptions();
        c_opt1.HeaderText = cacheStore.GetString("PatientLabel");
        c_opt1.FieldName = "PendingApprovalPatient";
        c_opt1.RowClickEnabled = true;
        c_opt1.WidthPercentageDefault = 8;
        c_opt1.IsSortable = true;
        c_opt1.SortColumn = PortfolioNotesSortOrderType.Patient;
        c_opt1.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt1.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.Patient;

        const c_opt2 = new MyleTableColumnOptions();
        c_opt2.HeaderText = cacheStore.GetString("ReasonLabel");
        c_opt2.FieldName = "PendingApprovalReason";
        c_opt2.WidthPercentageDefault = 8;
        c_opt2.RowClickEnabled = true;
        c_opt2.IsSortable = true;
        c_opt2.SortColumn = PortfolioNotesSortOrderType.Reason;
        c_opt2.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt2.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.Reason;

        const c_opt3 = new MyleTableColumnOptions();
        if (EmployeeTitleHelper.isStudent(sessionStore.myleEmployeeTitle)) {
            c_opt3.HeaderText = cacheStore.GetString("SupervisorLabel");
        }
        else {
            c_opt3.HeaderText = cacheStore.GetString("Staff1Label");
        }

        c_opt3.FieldName = "PendingApprovalSupervisor";
        c_opt3.WidthPercentageDefault = 8;
        c_opt3.RowClickEnabled = true;

        const c_opt4 = new MyleTableColumnOptions();
        c_opt4.HeaderText = cacheStore.GetString("ConsultationDateDLabel");
        c_opt4.FieldName = "PendingApprovalConsultationDate";
        c_opt4.RowClickEnabled = true;
        c_opt4.WidthPercentageDefault = 8;
        c_opt4.IsSortable = true;
        c_opt4.SortColumn = PortfolioNotesSortOrderType.ConsultationDate;
        c_opt4.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt4.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.ConsultationDate;

        const c_opt5 = new MyleTableColumnOptions();
        c_opt5.HeaderText = cacheStore.GetString("StatusLabel");
        c_opt5.FieldName = "PendingApprovalStatus";
        c_opt5.RowClickEnabled = true;
        c_opt5.IsSortable = true;
        c_opt5.SortColumn = PortfolioNotesSortOrderType.Status;
        c_opt5.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt5.WidthPercentageDefault = 8;
        c_opt5.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.Status;

        const c_opt6 = new MyleTableColumnOptions();
        c_opt6.HeaderText = cacheStore.GetString("EmissionLabel");
        c_opt6.FieldName = "PendingApprovalSendDate";
        c_opt6.WidthPercentageDefault = 8;
        c_opt6.IsSortable = true;
        c_opt6.RowClickEnabled = true;
        c_opt6.SortColumn = PortfolioNotesSortOrderType.Date;
        c_opt6.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt6.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.Date;

        const c_opt7 = new MyleTableColumnOptions();
        c_opt7.HeaderText = cacheStore.GetString("NotesLabel");
        c_opt7.FieldName = "PendingApprovalNotes";
        c_opt7.WidthPercentageDefault = 8;
        c_opt7.IsSortable = true;
        c_opt7.RowClickEnabled = true;
        c_opt7.SortColumn = PortfolioNotesSortOrderType.Notes;
        c_opt7.SortDirection = this.props.Model.get("OrderByDirection");
        c_opt7.IsSortActive = this.props.Model.get("OrderByColumn") === PortfolioNotesSortOrderType.Notes;

        const c_opt8 = new MyleTableColumnOptions();
        c_opt8.HeaderText = cacheStore.GetString("AnnexesLabel");
        c_opt8.FieldName = "Annexes";
        c_opt8.WidthPercentageDefault = 8;
        c_opt8.RowClickEnabled = true;

        cols.push(c_opt1);
        cols.push(c_opt2);
        cols.push(c_opt3);
        cols.push(c_opt4);
        cols.push(c_opt5);
        cols.push(c_opt6);
        cols.push(c_opt7);
        cols.push(c_opt8);

        return cols;
    }

    private getTableColumns(columnOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<PendingApprovalsTableItem>(
            columnOptions,
            column => {
                switch (column.FieldName) {
                    case "PendingApprovalPatient":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Status === PendingApprovalStatus.Pending) {
                                    return (<div><a onClick={this.onPatientClick.bind(this, item)}>{NameHelper.formatFullNameForHasPatientName(item.Model)}</a></div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                    return (<div className="red-text"><a onClick={this.onPatientClick.bind(this, item)}>{NameHelper.formatFullNameForHasPatientName(item.Model)}</a></div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                    return (<div className="green-text"><a onClick={this.onPatientClick.bind(this, item)}>{NameHelper.formatFullNameForHasPatientName(item.Model)}</a></div>);
                                }
                            }
                        };

                    case "PendingApprovalReason":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Status === PendingApprovalStatus.Pending) {
                                    return (<div>{item.Model.ReasonForVisit}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                    return (<div className="red-text">{item.Model.ReasonForVisit}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                    return (<div className="green-text">{item.Model.ReasonForVisit}</div>);
                                }
                            }
                        };

                    case "PendingApprovalStatus":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Status === PendingApprovalStatus.Pending) {
                                    return (<div>{cacheStore.GetString("PendingLabel")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                    return (<div className="red-text">{cacheStore.GetString("ReturnedLabel")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                    return (<div className="green-text">{cacheStore.GetString("ApprovedLabel")}</div>);
                                }
                            }
                        };

                    case "PendingApprovalSupervisor":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (EmployeeTitleHelper.isStudent(sessionStore.myleEmployeeTitle)) {
                                    if (item.Model.Status === PendingApprovalStatus.Pending) {
                                        return (<div>{cacheStore.GetCliniciansPersonsByContactId(item.Model.SupervisorContactId).NameWithPrefix}</div>);
                                    }
                                    else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                        return (<div className="red-text">{cacheStore.GetCliniciansPersonsByContactId(item.Model.SupervisorContactId).NameWithPrefix}</div>);
                                    }
                                    else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                        return (<div className="green-text">{cacheStore.GetCliniciansPersonsByContactId(item.Model.SupervisorContactId).NameWithPrefix}</div>);
                                    }
                                }
                                else {
                                    if (item.Model.Status === PendingApprovalStatus.Pending) {
                                        return (<div>{cacheStore.GetCliniciansPersonsByContactId(item.Model.ResidentContactId).NameWithPrefix}</div>);
                                    }
                                    else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                        return (<div className="red-text">{cacheStore.GetCliniciansPersonsByContactId(item.Model.ResidentContactId).NameWithPrefix}</div>);
                                    }
                                    else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                        return (<div className="green-text">{cacheStore.GetCliniciansPersonsByContactId(item.Model.ResidentContactId).NameWithPrefix}</div>);
                                    }
                                }
                            }
                        };

                    case "PendingApprovalConsultationDate":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Status === PendingApprovalStatus.Pending) {
                                    return (<div>{moment(item.Model.ConsultationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.ConsultationDate).format("hh:mm:ss")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                    return (<div className="red-text">{moment(item.Model.ConsultationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.ConsultationDate).format("hh:mm:ss")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                    return (<div className="green-text">{moment(item.Model.ConsultationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.ConsultationDate).format("hh:mm:ss")}</div>);
                                }
                            }
                        };

                    case "PendingApprovalSendDate":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Status === PendingApprovalStatus.Pending) {
                                    return (<div>{moment(item.Model.SendDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.SendDate).format("hh:mm:ss")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Returned) {
                                    return (<div className="red-text">{moment(item.Model.SendDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.SendDate).format("hh:mm:ss")}</div>);
                                }
                                else if (item.Model.Status === PendingApprovalStatus.Approved) {
                                    return (<div className="green-text">{moment(item.Model.SendDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(item.Model.SendDate).format("hh:mm:ss")}</div>);
                                }
                            }
                        };

                    case "PendingApprovalNotes":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.NumberOfNotes === 0) {
                                    return (<div style={{ width: "30px" }} onClick={this.onNotesPopupOpen.bind(this, item.Model)}><a>[+]</a></div>);
                                }
                                else {
                                    return (<div style={{ width: "30px" }} onClick={this.onNotesPopupOpen.bind(this, item.Model)}>[<a className="red-text">{item.Model.NumberOfNotes}</a>]</div>);
                                }
                            }
                        };

                    case "Annexes":
                        return {
                            renderCell: item => {
                                if (item.Model.IsAccessProhibited) {
                                    return (<div><span>{cacheStore.GetString("Allowlist_BlockedLabel")}</span></div>);
                                }
                                if (item.Model.Annexes == null || item.Model.Annexes.length === 0) {
                                    return (<div style={{ width: "30px" }}><a>--</a></div>);
                                }
                                else {
                                    return (
                                        <div>
                                            {item.Model.Annexes.map((ann, idx) => (
                                                <div key={"AnnHyp_" + item.Model.EncounterId + "_" + idx}>
                                                    <a onClick={e => this.openAnnex(ann, item.Model.EncounterId, item.Model.PatientContactId, item.Model.ConsultationDate, e)}>{ann.Name}</a>
                                                </div>
                                            ))}
                                        </div>
                                    );
                                }
                            }
                        };
                }
            },
            false
        );
    }

    private loadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        return Immutable.fromJS({
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: true,
            Autoresize: true,
            OnColumnWidthChange: null,
            HeightOffset: 65
        });
    }

    private onModifyEncounterClick(): void {
        const openPatientOperation = new LocalEvent(LocalOperations.Misc.RedirectToTab);

        openPatientOperation.AddItem("value", this.props.Model.get("SelectedPendingApprovalPatientContactId"));
        openPatientOperation.AddItem("target", RedirectTo.Patient);
        openPatientOperation.AddItem("currentLocation", RouterHistory.location);
        openPatientOperation.AddItem("OpenEncounterId", this.props.Model.get("SelectedPendingApprovalEncounterId"));
        openPatientOperation.AddItem("encounterEdit", false);

        LocalEventDispatcher.dispatch(openPatientOperation);
    }

    private onNotesPopupOpen(model: PendingApprovalsItem): void {
        const op = new LocalEvent(LocalOperations.Portfolio.PendingApproval_OnNotesPopupOpen);
        op.AddItem("encounterId", model.EncounterId);
        op.AddItem("patientContactId", model.PatientContactId);
        op.AddItem("employeeContactId", model.SupervisorContactId);
        op.AddItem("status", model.Status);
        LocalEventDispatcher.dispatch(op);
    }

    private openAnnex(annex: Annexes, encounterId: string, patientContactId: string, encounterConsultDate: Date, e: React.MouseEvent): void {
        e.stopPropagation();

        switch (annex.Type) {
            case "APSS":
                ApssClient.openForm(annex.Id, annex.ApsshistoricalId);
                break;

            case "CNESST":
                this.redirectToEncounter(encounterId, patientContactId);
                break;

            case "RADPDF":
                Client.openRadpdfForm(annex.Id, sessionStore.getCurrentEmployee().ContactFacetId, encounterId, encounterConsultDate, false, null); // Do not allow modif because we would have to call server to add the current employee to the note
                break;

            default:
                console.error(`Unknown form type '${annex.Type}', expected one of 'APSS', 'CNESST', or 'RADPDF'.`);
                break;
        }
    }

    private onCloseNotesPopup(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_CloseApprovalSupervisorPopup);
    }

    private onApprovePendingApprovalClick(): void {
        const tableData = this.props.Model.get("TableData");
        const encounterId = this.props.Model.get("SelectedPendingApprovalEncounterId");
        const selectedEncounter = tableData.filter(x => x.Model.EncounterId === encounterId).toArray().firstOrDefault();

        LinkingPopupService
            .promptForAdditionalSignOffInformation(
                this.props.Model.get("SelectedPendingApprovalPatientContactId"),
                selectedEncounter.Model.SiteId,
                selectedEncounter.Model.AppointmentId,
                null
            )
            .then(info => {
                sessionStore.dispatch(
                    LocalOperations.Portfolio.PendingApproval_OnApprovePendingApprovalClick,
                    {
                        forms: (selectedEncounter && selectedEncounter.Model.Annexes) || [],
                        additionalSignOffInformation: info
                    }
                );
            })
            .catch(p => p && console.error(p)); // prompt cancelled
    }

    private onReturnClick(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_OnReturnPendingApprovalClick);
    }

    private onReturnPendingApprovalMessageChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        const op = new LocalEvent(LocalOperations.Portfolio.PendingApproval_OnReturnPendingApprovalMessageChange);
        op.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(op);
    }

    private onPatientClick(item: PendingApprovalsTableItem): void {
        this.redirectToEncounter(item.Model.EncounterId, item.Model.PatientContactId);
    }

    private redirectToEncounter(encounterId: string, patientContactId: string): void {
        sessionStore.dispatch(
            LocalOperations.Misc.RedirectToTab,
            {
                value: patientContactId,
                target: RedirectTo.Patient,
                currentLocation: RouterHistory.location,
                OpenEncounterId: encounterId,
                encounterEdit: false
            }
        );
    }

    private getSelectedEncounter(): PendingApprovalsTableItem {
        const selectedEncounterId = this.props.Model.get("SelectedPendingApprovalEncounterId");

        return ArrayHelper.Find(this.props.Model.get("TableData").toArray(), x => x.Model.EncounterId == selectedEncounterId);
    }

    private toggleShowPdfNote(): void {
        // let operation = this.props.Model.get("PdfNoteOpen") == true ? LocalOperations.Portfolio.TogglePDFSideBar : LocalOperations.Portfolio.TogglePDFSideBar;
        // LocalEvent.Dispatch(operation);
        sessionStore.dispatch(LocalOperations.Portfolio.TogglePDFSideBar);
    }

    private getHeaderTitle(): string {
        return cacheStore.GetString(EmployeeTitleHelper.isDoctor(sessionStore.myleEmployeeTitle)
            ? "SupervisionLabel"
            : "SentForApprovalLabel"
        );
    }
}

export { PendingApprovalInbox };
